import Vue from "vue"
import VueRouter from "vue-router"
import Home from "../views/Home.vue"
import { store } from "@/store/index"

Vue.use(VueRouter)

const checkTabRedirect = (configKey, redirectKey) => async (to, from, next) => {
    const runtimeConfig = await fetch("./config/runtime.json").then(response => response.json())

    if (runtimeConfig[redirectKey]) {
        window.location.href = runtimeConfig[redirectKey]
        return
    }

    if (!runtimeConfig[configKey]) next(false)
    else next()
}

const routes = [
    {
        path: "/",
        name: "Home",
        component: Home,
        children: [
            {
                path: "/",
                component: () => import("@/components/Layout/Landing/Landing"),
            },
            {
                path: "/ads",
                component: () => import("@/components/Layout/Ads/Ads"),
                beforeEnter: checkTabRedirect("ShowAdTab", "ExternalCampaignTabLink"),
                meta: {
                  apiBodyGetPayload: "getAdsQuery",
                  apiBodyDefaultPayload: "getAdsQueryDefault",
                  apiBodySetPayload: "setAdsQuery",
                  tab: "Ads",
                  tabText: "Ad"
                }
            },
            {
                path: "/channels",
                component: () => import("@/components/Layout/Channels/Channels"),
                beforeEnter: checkTabRedirect("ShowChannelTab", "ExternalChannelTabLink"),
                meta: {
                  apiBodyGetPayload: "getChannelsQuery",
                  apiBodyDefaultPayload: "getChannelsQueryDefault",
                  apiBodySetPayload: "setChannelsQuery",
                  tab: "Channels",
                  tabText: "Channel"
                }
            },
            {
                path: "/programs",
                component: () => import("@/components/Layout/Programs/Programs"),
                beforeEnter: checkTabRedirect("ShowProgramTab", "ExternalProgramTabLink"),
                meta: {
                  apiBodyGetPayload: "getProgramsQuery",
                  apiBodyDefaultPayload: "getProgramsQueryDefault",
                  apiBodySetPayload: "setProgramsQuery",
                  tab: "Programs",
                  tabText: "Program"
                }
            },
            {
                path: "/overview",
                component: () => import("@/components/Layout/Overview/Overview"),
                meta: {
                    tab: "Overview",
                }
            },
        ],
    },
    {
        path: "/maintenance",
        name: "Maintenance",
        component: () => import("@/views/Maintenance.vue"),
    },
    {
        path: "*",
        redirect: "/",
    },
]

const router = new VueRouter({
    mode: "history",
    routes,
})

router.afterEach(() => {
    store.dispatch("checkCookieConsent")
})

export default router
